import TagManager from 'react-gtm-module'
import toUpper from 'lodash/toUpper'

const GTM_PAGE_DEFAULT = 'others'
const GTM_ID = 'GTM-WKFM8CM'

export const initGTMdataLayer = () => {
  TagManager.initialize({
    gtmId: GTM_ID,
    dataLayerName: 'dataLayer',
  })
}

export const sendGTMData = (data) => {
  TagManager.dataLayer({
    dataLayer: data,
    dataLayerName: 'dataLayer',
  })
}

const getGTMProps = (paginaCorrente, router, service_gift) => {
  let country = toUpper(router?.locale)
  let language = router?.locale
  let brand = service_gift?.nome == null ? 'Sipec' : service_gift?.nome
  let pageType = paginaCorrente?.page?.chiave || GTM_PAGE_DEFAULT
  let firstLevelCategory = ''
  let secondLevelCategory = ''
  let thirdtLevelCategory = ''

  if (pageType.includes('categoria')) pageType = 'listing'
  if (pageType.includes('homepage')) pageType = 'homepage'
  if (pageType.includes('cart')) pageType = 'cart'
  if (pageType.includes('checkout')) pageType = 'checkout'
  if (pageType.includes('myaccount')) pageType = 'profile'
  if (pageType.includes('articolo') || pageType.includes('prodotto')) pageType = 'product'

  if (pageType == 'listing' && router?.asPath) {
    let parts = router?.asPath.split('/')
    firstLevelCategory = parts[parts.indexOf('categoria') + 1] || ''
    secondLevelCategory = parts[parts.indexOf('categoria') + 2] || ''
    thirdtLevelCategory = parts[parts.indexOf('categoria') + 3] || ''
  }

  return {
    country,
    language,
    brand,
    pageType,
    firstLevelCategory,
    secondLevelCategory,
    thirdtLevelCategory,
  }
}

const getUtenteProps = (utente, router) => {
  let loginStatus = utente ? 'logged' : 'not_logged'
  let userID = utente ? utente?.id : 'not_logged'
  let wishListTotalItems = 0
  let cartTotalItems = 0
  let cartTotalValue = 0
  let agency_id = utente ? utente?.anagrafica_azienda_codice : 'not_logged'
  let checkout_type = router?.asPath.includes('personalizzazione') ? 'personalizzato' : 'neutro'

  return {
    loginStatus,
    userID,
    wishListTotalItems,
    cartTotalItems,
    cartTotalValue,
    agency_id,
    checkout_type,
  }
}

export const trackingCheckout = (carrello_main, step, dettaglio) => {
  let products = []
  let checkoutOpt = ''

  switch (step) {
    case 1:
      checkoutOpt = dettaglio ? 'ritiro' : 'spedizione'
      break
    case 2:
      checkoutOpt = dettaglio.toLowerCase().replace(/ /g, '_')
      break
    case 3:
      checkoutOpt = dettaglio == 'tm' ? 'trasporto_mia_intestazione' : 'trasporto_sipec'
      break
    case 4:
      checkoutOpt = null
      break
    case 5:
      checkoutOpt = dettaglio.toLowerCase().replace(/ /g, '_')
      break
  }

  for (let i = 0; carrello_main && i < carrello_main.righe_carrello?.length; i++) {
    products.push({
      name: carrello_main.righe_carrello[i]?.articolo?.titolo || '',
      id: carrello_main.righe_carrello[i]?.articolo?.codice || '',
      price: carrello_main.righe_carrello[i]?.prezzo_unitario_netto || '',
      brand: '', // $$$brand$$$
      category: '', // $$$product_category$$$
      variant: carrello_main.righe_carrello[i]?.articolo?.colore?.nome || '',
      quantity: carrello_main.righe_carrello[i]?.quantita || '',
      dimension14: carrello_main.righe_carrello[i]?.articolo?.taglia || '',
      dimension16: '', // $$$discount_name$$$
      dimension15: '', // $$$product_type$$$
      metric4: '', // $$$discount_value$$$
    })
  }

  sendGTMData({
    event: 'checkout',
    ecommerce: {
      currencyCode: 'EUR',
      checkout: {
        actionField: {
          step: step,
          option: checkoutOpt,
        },
        products: products,
      },
    },
  })
}

export const trackingPurchase = (info_ordine) => {
  let products = []

  for (let i = 0; info_ordine && i < info_ordine.righe_carrello?.length; i++) {
    products.push({
      name: info_ordine.righe_carrello[i]?.articolo?.titolo || '',
      id: info_ordine.righe_carrello[i]?.articolo?.codice || '',
      price: info_ordine.righe_carrello[i]?.prezzo_unitario_netto || '',
      brand: '', // $$$brand$$$
      category: '', // $$$product_category$$$
      variant: info_ordine.righe_carrello[i]?.articolo?.colore?.nome || '',
      quantity: info_ordine.righe_carrello[i]?.quantita || '',
      coupon: info_ordine.righe_carrello[i]?.coupon || '',
      dimension14: info_ordine.righe_carrello[i]?.articolo?.taglia || '',
      dimension16: '', // $$$discount_name$$$
      dimension15: '', // $$$product_type$$$
      metric4: '', // $$$discount_value$$$
    })
  }

  sendGTMData({
    event: 'purchase',
    ecommerce: {
      currencyCode: 'EUR',
      purchase: {
        actionField: {
          id: info_ordine?.id,
          affiliation: '',
          revenue: info_ordine?.totale,
          tax: info_ordine?.totale_imposta,
          shipping: info_ordine?.valore_trasporto,
          coupon: '',
          couponValue: '',
        },
        products: products,
      },
    },
  })
}

export const trackingProductPersonalization = (ID, category, action, label, sku) => {
  sendGTMData({
    event: 'GAevent',
    eventID: ID,
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    sku: sku,
  })
}

export const updateGTMDataLayer = (paginaCorrente, utente, router, service_gift) => {
  const gtmProps = getGTMProps(paginaCorrente, router, service_gift)
  const utenteProps = getUtenteProps(utente, router)

  sendGTMData({
    event: 'wSetup',
    ...gtmProps,
    ...utenteProps,
  })

  sendGTMData({
    event: 'virtual_pageview',
    pagePath: router.asPath, //pagePath: router.pathname.split('[token]')[0],
  })
}
